import { render, staticRenderFns } from "./ApplicantInfoStep.vue?vue&type=template&id=0f22d3be"
import script from "./ApplicantInfoStep.vue?vue&type=script&lang=ts"
export * from "./ApplicantInfoStep.vue?vue&type=script&lang=ts"
import style0 from "./ApplicantInfoStep.vue?vue&type=style&index=0&id=0f22d3be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports